"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
var _reactResizable = require("react-resizable");
var _utils = require("./utils");
var _datatableModule = _interopRequireDefault(require("./datatable.module.scss"));
var _excluded = ["onResize", "width"],
  _excluded2 = ["columns", "selectedRowKeys"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ResizeableTitle = function ResizeableTitle(props) {
  var onResize = props.onResize,
    width = props.width,
    restProps = _objectWithoutProperties(props, _excluded);
  if (!width) {
    return /*#__PURE__*/_react["default"].createElement("th", restProps);
  }
  return /*#__PURE__*/_react["default"].createElement(_reactResizable.Resizable, {
    width: width,
    height: 0,
    onResize: onResize,
    draggableOpts: {
      enableUserSelectHack: false
    }
  }, /*#__PURE__*/_react["default"].createElement("th", restProps));
};
var ArcDataTable = /*#__PURE__*/function (_React$Component) {
  _inherits(ArcDataTable, _React$Component);
  var _super = _createSuper(ArcDataTable);
  function ArcDataTable(props) {
    var _this;
    _classCallCheck(this, ArcDataTable);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "components", _objectSpread(_objectSpread({}, _this.props.components), {}, {
      header: {
        cell: ResizeableTitle
      }
    }));
    _defineProperty(_assertThisInitialized(_this), "handleResize", function (index) {
      return function (e, _ref) {
        var size = _ref.size;
        _this.setState(function (_ref2) {
          var columns = _ref2.columns;
          var nextColumns = _toConsumableArray(columns);
          nextColumns[index] = _objectSpread(_objectSpread({}, nextColumns[index]), {}, {
            width: size.width
          });
          return {
            columns: nextColumns
          };
        });
      };
    });
    _defineProperty(_assertThisInitialized(_this), "onSelectChange", function (selectedRowKeys) {
      _this.setState({
        selectedRowKeys: selectedRowKeys
      });
    });
    _this.state = {
      pagination: false,
      hasData: true,
      top: 'none',
      bottom: 'bottomRight',
      columns: (0, _utils.serializeColumns)(_this.props.data.columns, props.onRowAction),
      selectedRowKeys: []
    };
    _this.defaultProps = {
      rowSelection: props.rowSelection ? props.rowSelection : true
    };
    return _this;
  }
  _createClass(ArcDataTable, [{
    key: "render",
    value:
    //   let colHeader = serializeColumns(this.props.expandable.columns).map(
    //     (col, index) => ({
    //       ...col,
    //       onHeaderCell: (column) => ({
    //         width: column.width,
    //         onResize: this.handleResize(index),
    //       }),
    //       title: () => (
    //         <div>
    //           <span className={styles.displayName}>{col["displayName"]}</span>
    //         </div>
    //       ),
    //     })
    //   );

    //   return (
    //     <Table
    //       showHeader={this.props.expandable.showHeader}
    //       columns={colHeader}
    //       dataSource={this.props.expandable.rows}
    //       pagination={false}
    //     />
    //   );
    // };
    function render() {
      var _this2 = this;
      var _this$state = this.state,
        columns = _this$state.columns,
        selectedRowKeys = _this$state.selectedRowKeys,
        state = _objectWithoutProperties(_this$state, _excluded2);
      var _this$props = this.props,
        data = _this$props.data,
        _onRow = _this$props.onRow,
        customColumns = _this$props.customColumns,
        height = _this$props.height,
        overflow = _this$props.overflow,
        rowKey = _this$props.rowKey,
        _this$props$paginatio = _this$props.pagination,
        pagination = _this$props$paginatio === void 0 ? false : _this$props$paginatio;
      var colHeader = columns.map(function (col, index) {
        return _objectSpread(_objectSpread({}, col), {}, {
          onHeaderCell: function onHeaderCell(column) {
            return {
              width: column.width,
              onResize: _this2.handleResize(index)
            };
          },
          title: function title() {
            return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
              className: _datatableModule["default"].displayName
            }, col['displayName']));
          }
        });
      });
      if (customColumns) {
        colHeader = (0, _utils.columnsAdd)(colHeader, customColumns);
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _datatableModule["default"].dataWrapper
      }, /*#__PURE__*/_react["default"].createElement(_lib.Table, _extends({}, this.state, {
        rowKey: rowKey ? rowKey : 'id',
        pagination: pagination,
        expandable: this.props.expandble,
        columns: colHeader //columns
        ,
        dataSource: state.hasData ? data.rows : null //rows
        ,
        components: this.components,
        rowSelection: this.props.rowSelection,
        onRow: function onRow(record, index) {
          return {
            onClick: function onClick() {
              _onRow ? _onRow(record, index) : _this2.onRow = function () {};
            }
          };
        },
        scroll: {
          x: 'max-content',
          y: height ? height : "calc(100vh - ".concat(overflow ? overflow : '57.5vh', " )")
        }
      })));
    }
  }]);
  return ArcDataTable;
}(_react["default"].Component);
var _default = ArcDataTable;
exports["default"] = _default;